export const websiteConfigurations = {
  'flat.com.br': {
    name: 'Flat Brasil',
    email: 'info@flat.com.br',
    gtag: 'G-HYB21KHC60',
    domain: '*.flat.com.br',
    canonicalDomain: 'www.flat.com.br', // Optional: Canonical domain for SEO-friendly redirect
    supportNumber: '',
    languageCode: 'pt',
    countryCode: 'br',
    currencyCode: 'brl',
    coverVideo: '/videos/cities/sao-paulo.mp4', // Looping hero video shown next to search (falls back to cover image when absent)
    websiteId: 1,
    listingName: 'flat',
    listingId: 5,
    marketplaceId: 1001,
    organizationId: 4,
    bookingFee: 699,
    taxIds: [
      { type: 'cpf', placeholder: '000.000.000-00' },
      { type: 'cnpj', placeholder: '00.000.000/0000-00' }
    ],
    stripeAccount: {
      capabilities: {
        boleto_payments: { requested: true },
        pix_payments: { requested: true },
        card_payments: { requested: true },
        transfers: { requested: true }
      }
    },
    youtube: '@flat-com-br',
    instagram: 'flat.com.br',
    facebook: 'flat.com.br',
    joinVideo: 'https://customer-0gtubku1qqxqp6q1.cloudflarestream.com/e23483a83c84820e911564aea3140db8/iframe',
    contactForm: '1FAIpQLSdNwoSFeVmwtRm9u3iTjDsJaC_gGAvqw-dJAFlarn7Xq_IV1A',
    pricing: {
      landlord: {
        request: {
          commission: {
            midTermRental: '5',
            basedOn: 'net'
          },
          addingOffer: 49
        },
        instant: {
          commission: {
            midTermRental: '10',
            basedOn: 'gross'
          },
          addingOffer: 49
        },
      },
      agent: {
        request: {
          commission: {
            midTermRental: '5',
            basedOn: 'net'
          },
          addingOffer: 49
        },
        instant: {
          commission: {
            midTermRental: '7',
            basedOn: 'gross'
          },
          addingOffer: 49
        },
      },
      apartHotel: {
        request: {
          commission: {
            midTermRental: '10',
            basedOn: 'gross'
          },
          addingOffer: 0
        },
        instant: {
          commission: {
            midTermRental: null,
            basedOn: 'gross'
          },
          addingOffer: 0
        },
      },
    },
    locations: [
      {'name': 'sao-paulo', primary: true },
      {'name': 'guarulhos', primary: true },
      {'name': 'osasco'},
      {'name': 'barueri'},
      {'name': 'curitiba', primary: true }
    ]
  },
  'flat.com.pa': {
    name: 'Flat Panama',
    email: 'info@flat.com.pa',
    gtag: 'G-VMNQQ5K5Y8',
    domain: '*.flat.com.pa',
    canonicalDomain: 'www.flat.com.pa', // Optional: Canonical domain for SEO-friendly redirect
    supportNumber: '',
    languageCode: 'en',
    countryCode: 'pa',
    currencyCode: 'usd',
    coverVideo: '/videos/cities/panama-city.mp4', // Looping hero video shown next to search (falls back to cover image when absent)
    websiteId: 9,
    listingName: 'flat-com-pa',
    listingId: 7,
    marketplaceId: 1002,
    organizationId: 7,
    bookingFee: 29,
    taxIds: [
      { type: 'cedula', placeholder: 'E-8-123456' },
      { type: 'ruc', placeholder: '123456-1-123456' }
    ],
    stripeAccount: {
      capabilities: {
        transfers: { requested: true }
      },
      controller: {
        stripe_dashboard: {
          type: 'none',
        },
        fees: {
          payer: 'application',
        },
        losses: {
          payments: 'application',
        },
        requirement_collection: "application",
      },
      tos_acceptance: {
        service_agreement: "recipient"
      }
    },
    youtube: '@flat-com-pa',
    instagram: 'flat.com.pa',
    facebook: 'flat.com.pa',
    joinVideo: 'https://customer-gu68vvi5z5ohg3j0.cloudflarestream.com/f806661ccd3afbf13157d35a2eec231f/iframe',
    contactForm: '1FAIpQLSfyntJrtqqKdWZCM3IuEvW09abTF9CEdcf6J6_vngIIOG2s2A',
    pricing: {
      landlord: {
        request: {
          commission: {
            midTermRental: '5',
            basedOn: 'gross'
          },
          addingOffer: 99
        },
        instant: {
          commission: {
            midTermRental: '10',
            basedOn: 'gross'
          },
          addingOffer: 99
        },
      },
      agent: {
        request: {
          commission: {
            midTermRental: '5',
            basedOn: 'gross'
          },
          addingOffer: 99
        },
        instant: {
          commission: {
            midTermRental: '7',
            basedOn: 'gross'
          },
          addingOffer: 99
        },
      },
      apartHotel: {
        request: {
          commission: {
            midTermRental: '10',
            basedOn: 'gross'
          },
          addingOffer: 0
        },
        instant: {
          commission: {
            midTermRental: null,
            basedOn: 'gross'
          },
          addingOffer: 0
        },
      },
    },
    locations: [
      {'name': 'panama-city', primary: true},
      {'name': 'pacific-coast-beaches', type: 'region', primary: true},
      {'name': 'nueva-gorgona', 'region': 'pacific-coast-beaches'},
      {'name': 'playa-coronado', 'region': 'pacific-coast-beaches'},
      {'name': 'rio-hato', 'region': 'pacific-coast-beaches'},
      {'name': 'san-carlos', 'region': 'pacific-coast-beaches'},
      {'name': 'veracruz'},
      {'name': 'punta-chame'},
      {'name': 'valle-de-anton'},
      {'name': 'pedasi'},
      {'name': 'playa-venado'},
      {'name': 'boquete', primary: true}
    ]
  },
  'default': {
    name: 'Flat Brasil',
    email: 'info@flat.com.br',
    gtag: 'G-HYB21KHC60',
    domain: '*',
    supportNumber: '',
    languageCode: 'pt',
    countryCode: 'br',
    currencyCode: 'brl',
    coverVideo: '/videos/cities/sao-paulo.mp4', // Looping hero video shown next to search (falls back to cover image when absent)
    websiteId: 1,
    listingName: 'flat',
    listingId: 5,
    marketplaceId: 1001,
    organizationId: 4,
    bookingFee: 699,
    stripeAccount: {
      controller: {
        stripe_dashboard: {
          type: 'none',
        },
        fees: {
          payer: 'account',
        },
      },
      capabilities: {
        boleto_payments: { requested: true },
        pix_payments: { requested: true },
        card_payments: { requested: true },
        transfers: { requested: true }
      }
    },
    youtube: '@flat-com-br',
    instagram: 'flat.com.br',
    facebook: 'flat.com.br',
    joinVideo: 'https://customer-gu68vvi5z5ohg3j0.cloudflarestream.com/f806661ccd3afbf13157d35a2eec231f/iframe',
    contactForm: '1FAIpQLSdNwoSFeVmwtRm9u3iTjDsJaC_gGAvqw-dJAFlarn7Xq_IV1A',
    pricing: {
      landlord: {
        request: {
          commission: {
            midTermRental: '5',
            basedOn: 'net'
          },
          addingOffer: 49
        },
        instant: {
          commission: {
            midTermRental: '10',
            basedOn: 'gross'
          },
          addingOffer: 49
        },
      },
      agent: {
        request: {
          commission: {
            midTermRental: '5',
            basedOn: 'net'
          },
          addingOffer: 49
        },
        instant: {
          commission: {
            midTermRental: '7',
            basedOn: 'gross'
          },
          addingOffer: 49
        },
      },
      apartHotel: {
        request: {
          commission: {
            midTermRental: '10',
            basedOn: 'gross'
          },
          addingOffer: 0
        },
        instant: {
          commission: {
            midTermRental: null,
            basedOn: 'gross'
          },
          addingOffer: 0
        },
      },
    },
    locations: [
      {'name': 'sao-paulo', primary: true },
      {'name': 'guarulhos', primary: true },
      {'name': 'osasco'},
      {'name': 'barueri'},
      {'name': 'curitiba', primary: true }
    ]
  }
};
